// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"67413b45","204":"bfc20038","310":"26102454","346":"481a73e9"}[chunkId] + ".chunk.css";
};